import {
  CAMPAIGN_FLOW_NAME,
  COMPANY_TEST_URL,
  LAST_LOGIN_DATE,
  MFA_REASON,
  ORG_MAILING_ADDRESS,
  OTHER_EMAILS,
  PROFILE_NAMES, RECENT_INVOICE,
} from '../utils/ZD_FIELD_IDS';
import type { ICustomZendeskField } from '@klv/organisms/form-account-access/types';

export const MFA_SUPPORT_ZENDESK_ID = {
  MFA_REASON,
  COMPANY_TEST_URL,
  ORG_MAILING_ADDRESS,
  PROFILE_NAMES,
  LAST_LOGIN_DATE,
  CAMPAIGN_FLOW_NAME,
  OTHER_EMAILS,
  RECENT_INVOICE,
};

// custom fields for mfa support no longer used. //
export const companyTestUrl: ICustomZendeskField = {
  id: COMPANY_TEST_URL,
};

export const orgMailingAddress: ICustomZendeskField = {
  id: ORG_MAILING_ADDRESS,
};

export const profileNames: ICustomZendeskField = {
  id: PROFILE_NAMES,
};

export const lastLoginDate: ICustomZendeskField = {
  id: LAST_LOGIN_DATE,
};

export const campaignFlowName: ICustomZendeskField = {
  id: CAMPAIGN_FLOW_NAME,
};

export const otherEmails: ICustomZendeskField = {
  id: OTHER_EMAILS,
};

export const recentInvoice: ICustomZendeskField = {
  id: RECENT_INVOICE,
};

// no longer used.
export const supportFields = {
  companyTestUrl,
  orgMailingAddress,
  profileNames,
  lastLoginDate,
  campaignFlowName,
  otherEmails,
  recentInvoice,
};
